/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

import { Component, OnInit } from '@angular/core';
import Cookies from 'js-cookie';
import { DatePipe } from '@angular/common';
import { AppConfigService } from '../../../common/services/app-config/app-config.service';

/**
 * Component to display shutdown alert.
 */
@Component({
  selector: 'bulb-shutdown-alert',
  templateUrl: './shutdown-alert.component.html',
  styleUrls: ['./shutdown-alert.component.scss'],
  standalone: false,
})
export class ShutdownAlertComponent implements OnInit {

  /**
   * shutdown alert flag.
   */
  shutdownAlertFlag: boolean = false;

  /**
   * Date which is shown in alert.
   */
  alertDate: any;

  /**
   * Default constructor
   * @param appConfig
   * @param datePipe
   */
  constructor(
    private appConfig: AppConfigService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit(): void {
    // shutdown alert work
    const alertDateString = this.appConfig.shutdownAlert?.alert?.date;
    this.alertDate = new Date(alertDateString)?.toString();

    const shutdownAlertStartingDate = this.appConfig.shutdownAlert?.alert?.startDate;
    const todayDate = new Date();
    this.compareDates(shutdownAlertStartingDate, todayDate.toLocaleDateString('en-us'));
  }

  /**
   * We are formatting and comparing dates
   * @param shutdownAlertStartingDate Date from which alert will be shown.
   * @param todayDate Today's Date
   */
  compareDates(shutdownAlertStartingDate, todayDate) {
    const formattedShutdownAlertStartDate = new Date(this.datePipe.transform(shutdownAlertStartingDate, 'yyyy-MM-dd'));
    const formattedTodayDate = new Date(this.datePipe.transform(todayDate, 'yyyy-MM-dd'));

    if (formattedShutdownAlertStartDate <= formattedTodayDate) {
      const dateInMS = Cookies.get('bulb-shutdownAlert-cookies');
      const shutdownAlertAcceptedDate = this.convertMillisecondsToDate(dateInMS);
      const afterSevenDaysDate = this.calculateDateAfterSevenDays(shutdownAlertAcceptedDate);
      this.calculateReshowDate(shutdownAlertAcceptedDate, afterSevenDaysDate);
    }
  }

  /**
   * Convert into date from millisecond.
   * @param dateInMS Contains date in ms.
   * @returns Date in date format.
   */
  // eslint-disable-next-line class-methods-use-this
  convertMillisecondsToDate(dateInMS: any): Date | null {
    const milliseconds = Number(dateInMS);
    const date = new Date(milliseconds);
    return date;
  }

  /**
   * Calculate after seven days date of alert accepted date
   * @param shutdownAlertAcceptedDate Date on which alert need to be shown.
   */
  calculateDateAfterSevenDays(shutdownAlertAcceptedDate: Date): Date {
    const date = new Date(shutdownAlertAcceptedDate);
    date.setDate(date.getDate() + parseInt(this.appConfig.shutdownAlert?.alert?.reshowDelay, 10));
    return date;
  }

  /**
   * Method use to check shutdown alert need to show or not
   * @param shutdownAlertAcceptedDate Date on which alert need to be shown.
   * @param afterSevenDaysDate Next date after which alert need to be shown.
   */
  calculateReshowDate(shutdownAlertAcceptedDate: Date, afterSevenDaysDate: Date) {
    const todayDate = new Date();
    // this.shutdownAlertFlag = !(todayDate > shutdownAlertAcceptedDate && todayDate < afterSevenDaysDate);
  }

  /**
   * Method is called when user click on alert acceptance button.
   */
  alertAccepted() {
    const currentTime = Date.now();
    Cookies.set('bulb-shutdownAlert-cookies', currentTime.toString());
    this.shutdownAlertFlag = false;
  }
}
